import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, mergeMap, of, switchMap, throwError } from 'rxjs';
import { Impresa } from 'src/app/applicant/models/impresa';
import { LiberoProfessionista } from 'src/app/applicant/models/libero-professionista';
import { environment } from '../../../environments/environment';
import { IPratica, Pratica, StatoPratica } from '../../../interfaces/pratica';
import { PersonaGiuridica } from '../../applicant/models/persona-giuridica';
import { IKpi } from '../../requests/models/kpi-model';
import { ExecuteScoreResponse } from '../../score/execute-score-response';
import { IOutsystemResponse } from '../../score/outsystem-response';
import {
  IPropostaIndicativa,
  PropostaIndicativa,
} from '../../score/proposta-indicativa';
import { Account, BEAccount } from '../../../interfaces/account';
import { Product } from '../../requests/models/product';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class OutsystemService {
  private readonly baseEndpoint = `${environment.api}/outsystem-adapter/api`;
  private readonly osEndpoint = `out-system`;

  constructor(private http: HttpClient) {}

  createProposal(
    score: ExecuteScoreResponse,
    pratica: Pratica,
    personaGiuridica: PersonaGiuridica | Impresa | LiberoProfessionista,
    commissioni: number | undefined
  ) {
    let body: IPropostaIndicativa = PropostaIndicativa.createProposalBody(
      score,
      pratica,
      personaGiuridica,
      commissioni
    );
    return this.http
      .put<IOutsystemResponse>(
        `${this.baseEndpoint}/v2/${this.osEndpoint}/proposta-indicativa`,
        body
      )
      .pipe(
        mergeMap((res) => {
          if (res.Errore) {
            return throwError(() => res.Errore);
          } else {
            return of(res);
          }
        })
      );
  }

  updateKpi(updatedKpi: Partial<IKpi>) {
    return this.http
      .put<IKpi>(
        `${this.baseEndpoint}/${this.osEndpoint}/update-kpi`,
        updatedKpi
      )
      .pipe(
        mergeMap((res) => {
          if (res.Errore) {
            return throwError(() => res.Errore);
          } else {
            return of(res);
          }
        })
      );
  }
}
